import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'

import {
  finishQuiz,
  isErrorSelector,
  isLoadingSelector,
  lengthSelector,
  startQuiz,
} from '@/services/slices/questionSlice'
import { AppDispatch } from '@/store'
import Button from '@/ui/Button/Button'
import Logo from '@/ui/icons/Logo'
import { getQuestions } from '@/utils/api'
import classNames from 'classnames'

import styles from './styles.module.scss'

const QuizPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const isError = useSelector(isErrorSelector) as any
  const isLoading = useSelector(isLoadingSelector)
  const questionsCount = useSelector(lengthSelector)

  const onStartQuiz = useCallback(() => {
    navigate('/questions')
    dispatch(startQuiz())
  }, [dispatch, navigate])

  const onLanding = useCallback(() => {
    navigate('/')
  }, [navigate])

  useEffect(() => {
    dispatch(finishQuiz())
    dispatch(getQuestions())
  }, [dispatch])

  return (
    <div className={styles.quiz}>
      <div className={styles.quiz_container}>
        <div className={styles.quiz_container_link}>
          <a href="https://2gis.ru" target="_blank" rel="noopener noreferrer">
            <Logo />
          </a>
        </div>
        <div className={styles.quiz_container_info}>
          <h2
            className={classNames(
              'text',
              't-header-h2',
              'text_color_primary',
              styles.heading,
            )}
          >
            Кто здесь <br /> самый-самый?
          </h2>
          {isMobile ? (
            <p
              className={classNames(
                'text',
                't-body',
                'text_color_primary',
                styles.paragraph,
              )}
            >
              Россия глубока, широка и&nbsp;высока. Это точно знает 2ГИС, потому
              что мы&nbsp;всё измерили и&nbsp;подсчитали. Теперь мы&nbsp;знаем,
              где самый многоквартирный в&nbsp;стране дом, самая большая
              бесплатная парковка и&nbsp;самая длинная улица.
            </p>
          ) : (
            <p
              className={classNames(
                'text',
                't-body',
                'text_color_primary',
                styles.paragraph,
              )}
            >
              Россия глубока, широка и&nbsp;высока. Это точно знает 2ГИС, потому
              что мы&nbsp;всё измерили и&nbsp;подсчитали. Теперь мы&nbsp;знаем,
              в&nbsp;каком городе самый многоквартирный дом, самая большая
              бесплатная парковка, самая длинная улица и&nbsp;другие рекорды.
              <br />
              <br />
              Прежде чем узнать, что и&nbsp;где в&nbsp;стране самое-самое,
              попробуйте угадать! Мы&nbsp;подготовили квиз на&nbsp;
              {questionsCount}&nbsp;вопросов о&nbsp;разных рекордах. Ваша
              задача&nbsp;&mdash; правильно выбрать город.
            </p>
          )}
        </div>
        <div className={styles.button_wrapper}>
          <Button
            type="accent"
            size={isMobile ? 'fullsize' : 'medium'}
            onClick={onStartQuiz}
            disabled={isLoading || isError}
            className={classNames({ [styles.quiz_button]: !isMobile })}
          >
            Играть
          </Button>
          <Button
            type={isMobile ? 'primary' : 'secondary'}
            size={isMobile ? 'fullsize' : 'medium'}
            withBorder
            linkTo="/#records"
            onClick={onLanding}
            className={styles.quiz_button}
          >
            Сразу к рекордам
          </Button>
        </div>
      </div>
    </div>
  )
}

export default QuizPage
